import { Navigate } from 'react-router-dom';
import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const errorRoutes: RouteConfig[] = [
  {
    path: '/unauthorized',
    element: <Components.UnauthorizedPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '/404',
    element: <Components.NotFoundPage />,
    requiresAuth: false,
    requiresLayout: false,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
    requiresAuth: false,
    requiresLayout: false,
  },
];
